module.exports = __webpack_public_path__ + "app/docrepo-invoice/detail/json-EivIkSic.html";